import { entry } from './actions/entry';
import { call } from './actions/call';
import { queue } from './actions/queue';
import { menu } from './actions/menu';
import { playback } from './actions/playback';
import { postback } from './actions/postback';
import { time } from './actions/time';
import { list } from './actions/list';

export const worksheet = {
  status: {
    active: 'Активно',
    draft: 'Неактивная'
  },

  tooltips: {
    drag_and_drop: 'Переместите в рабочую область необходимые элементы схемы.'
  },

  modal: {
    remove: {
      content: `Вы действительно хотите удалить схему <b>{name}<b>?`
    },

    remove_action: {
      content: `Вы уверены что хотите удалить сервис <b>{name}</b> на схеме?`
    },

    remove_relationship: {
      content: `Вы уверены что хотите удалить связь?`
    },

    create_relationship: {
      title: `Создание связи`,
      content: 'Выберите условие соединения'
    },

    action: {
      main: {
        button: {
          ok: '@:shared.component.button.save',
          cancel: '@:shared.component.button.cancel'
        }
      },

      child: {
        button: {
          ok: '@:shared.component.button.confirm',
          cancel: '@:shared.component.button.back'
        }
      }
    }
  },

  action: {
    type: {
      time: 'Условие по времени',
      queue: 'Очередь',
      list: 'Фильтр по номеру',
      menu: 'Голосовое меню IVR',
      playback: 'Автоинформатор',
      postback: 'Постбэк',
      url: 'URL',
      call: 'Переадресация контакту',
      entry: 'Точка входа',
      start: 'Автоинформатор',
      media: 'Медиа файл'
    },

    field: {
      name: {
        title: 'Название сервиса на&nbsp;схеме'
      }
    },

    entry,
    call,
    queue,
    menu,
    playback,
    postback,
    time,
    list
  }
};
